import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { GET_CHANGE_FAILURE_RATE_RANGE } from "./gql";

type UseGetChangeFailureRateRangeProps = {
  startTimeUnix: number;
  endTimeUnix: number;
};

const useGetChangeFailureRateRange = ({
  startTimeUnix,
  endTimeUnix,
}: UseGetChangeFailureRateRangeProps) => {
  const { data, loading, error, refetch, networkStatus, previousData } = usePolledQuery(
    GET_CHANGE_FAILURE_RATE_RANGE,
    {
      variables: { input: { startTime: startTimeUnix, endTime: endTimeUnix } },
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  // Returns raw backend DataPoints (timestamp unix, value as ratio 0–1)
  const range =
    data?.metricsRange?.changeFailureRateRange ??
    previousData?.metricsRange?.changeFailureRateRange;

  return {
    range,
    hasRuns: !!data?.metricsRange?.hasRuns,
    loading,
    error,
    refetch,
    networkStatus,
  };
};

export default useGetChangeFailureRateRange;
